import Text from 'components/corporatiu/Text';
import LlistatContingut from 'components/corporatiu/LlistatContingut';
import styles from './itemdocument.module.scss';

const ItemDocument = (props) => {
    const { item } = props;
    const { titol, resum, text, docs_transparencia, id } = item;
    return (
        <div>
            <article className={styles.infoDocument}>
                <header>
                    <h1 className={styles.titol}>{titol}</h1>
                    <div className={styles.entradeta}>
                        <Text text={resum} />
                    </div>
                </header>
                <div className={styles.cos}>
                    <Text text={text} />
                </div>
            </article>
            {docs_transparencia && <LlistatContingut items={docs_transparencia} routeType='web_transparencia_item_document' />}
        </div>
    );
};

export default ItemDocument;
